import { Component } from '@angular/core';

@Component({
    selector: 'account-management-page',
    templateUrl: './account-management-page.component.html',
    styleUrls: ['./account-management-page.component.css'],
    standalone: false
})
export class AccountManagementPageComponent {}
